import { ClientAssociationGroup } from '@blisspointmedia/bpm-types/dist/ClientAssociations';

export const findDuplicateGroupName = (
  clientId: string,
  currentRowId: string | undefined,
  otherGroups: ClientAssociationGroup[]
): string | undefined => {
  for (const group of otherGroups) {
    if (group.id === currentRowId) continue;
    if (group.deleted_at !== null) continue;
    if (group.client_ids.includes(clientId)) return group.name;
  }
  return undefined;
};
